import { render, staticRenderFns } from "./LmTagsInput.vue?vue&type=template&id=191e9709&"
import script from "./LmTagsInput.vue?vue&type=script&lang=js&"
export * from "./LmTagsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports